import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=3b537b0d&"
import script from "./PermissionsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports